module.exports = __webpack_public_path__ + "img/mono_23.b4afb048.png";